export const withMask = (float: number) => {
  const numberFormat = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return numberFormat.format(float);
};
